module.exports = __webpack_public_path__ + "img/3d-mobile_jp.c8575a7.jpg";